<template>
    <div class="login-form">
        <login-step1
            v-if="step == 1"
            :lang="lang"
            :login_social="login_social"
            @next="nextStep($event)"
            @loginSuccess="onLoginSuccess($event)"
        />

        <login-step2
            v-if="step == 2"
            :lang="lang"
            @next="loginStep($event)"
            @loginSuccess="onLoginSuccess($event)"
        />

        <login-step3
            v-if="step == 3"
            :lang="lang"
            @registerSuccess="onRegisterSuccess($event)"
        />
    </div>
</template>

<script>
import { Form } from '../classes/Form'

import AppleLoginButton from './AppleLoginButton.vue'
import FacebookLoginButton from './FacebookLoginButton.vue'
import GoogleLoginButton from './GoogleLoginButton.vue'
import LoginStep1 from './login-form/Step1.vue'
import LoginStep2 from './login-form/Step2.vue'
import LoginStep3 from './login-form/Step3.vue'

export default {
    components: {
        'apple-login-button': AppleLoginButton,
        'facebook-login-button': FacebookLoginButton,
        'google-login-button': GoogleLoginButton,
        'login-step1': LoginStep1,
        'login-step2': LoginStep2,
        'login-step3': LoginStep3
    },

    props: {
        triggers_an_action: {
            type: Boolean,
            default: false,
        },

        target: {
            type: String,
            default: 'dashboard',
        },

        login_social: {
            type: Object,
            require: true,
        }
    },

    data() {
        return {
            step: 1,
            form_login: new Form({
                email: '',
                password: '',
            }),
            // form_register: new Form({
            //     email: '',
            //     first_name: '',
            //     last_name: '',
            //     password: '',
            //     password_verify: '',
            //     phone: ''
            // }),
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },
    },

    methods: {
        nextStep(data) {
            this.step = data.step
            this.form_login.email = data.email
        },

        loginStep(data) {
            this.form_login.password = data

            this.form_login.post('/api/login')
                .then(data => {
                    this.onLoginSuccess(data)
                })
                .catch(response => {
                    if(response.status !== 419) {
                        flash(response.data.message, 'warning')
                        this.error = this.lang.errors.authentication
                    }
                })
        },

        onLoginSuccess(data) {
            if (data.hash) {
                this.$root.user_hash = data.hash
                this.$root.user_email = data.email

                if(this.triggers_an_action) {
                    window.events.$emit('hideModal', { name: 'login' })

                    window.events.$emit('login_completed')
                }
                else {
                    let target = this.target ? this.target : 'dashboard'

                    location.href = this.lang.user_area_routes[target]
                }
            } else {
                flash(this.lang.messages.register)
                this.$parent.close()
            }
        },

        onRegisterSuccess(data) {
            this.form_register = data
            this.form_register.email = this.form_login.email

            this.form_register.post('/api/user-register', {reset: false})
                .then(data => {
                    flash(this.lang.messages.register)
                    this.$parent.close()
                })
                .catch(response => {
                    if(response.status !== 419) {
                        flash(response.data.message, 'warning')
                        this.error = this.lang.errors.authentication
                    }
                })
        }
    },
}
</script>